import { Provider as StoreProvider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import store from '@App/app.store';

import StillWaterLegend from '../../../StillWaterLegend/StillWaterLegend.jsx';

import './still-water-legend-control.css';

class StillWaterLegendControl {
  constructor(maximums) {
    this._maximums = maximums;
  }

  onAdd() {
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl flowing-water-legend-control';
    this._root = createRoot(this._container);
    this._root.render(
      <StoreProvider store={store}>
        <StillWaterLegend maximums={this._maximums} />
      </StoreProvider>,
    );
    return this._container;
  }

  onRemove() {
    this._root?.unmount();
    this._container?.remove();
  }
}

export default StillWaterLegendControl;
